export const CErrorModakTypes = {
    NEW: 'NEW',
    CAUSE: 'CAUSE',
    CODE : 'CODE',
    NONE: 'NONE'
} as const;